import { lazy } from 'react';

import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from 'utils/route-guard/AuthGuard';

const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const Payments = Loadable(lazy(() => import('pages/payments')));
const Webhooks = Loadable(lazy(() => import('pages/webhooks')));
const Settings = Loadable(lazy(() => import('pages/settings')));

const MainRoutes = {
  path: '/',
  element: <AuthGuard><DashboardLayout /></AuthGuard>,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />
    },
    {
      path: 'payments',
      element: <Payments />
    },
    {
      path: 'webhooks',
      element: <Webhooks />
    },
    {
      path: 'settings',
      element: <Settings />
    }
  ]
};

export default MainRoutes;
